const routes = {
    name: 'Labor',
    icon: 'mdi-timer-sand',
    path: '/reports/timhortons/labor/',
    children: [
      {
        path: '/reports/timhortons/labor/crewTraining',
        name: 'Crew Training',
        component: () => import('./CrewTraining.vue'),
        permissions: ['thCrewTraining'],
      },
      {
        path: '/reports/timhortons/labor/dailyLaborHours',
        name: 'Daily Labor Hours',
        component: () => import('./DailyLaborHours.vue'),
        permissions: ['thDailyLaborHours'],
      },
      {
        path: '/reports/timhortons/labor/weeklyLaborHours',
        name: 'Weekly Labor Hours',
        component: () => import('./WeeklyLaborHours.vue'),
        permissions: ['thWeeklyLaborHours'],
      },
      {
        path: '/reports/timhortons/labor/laborSummary',
        name: 'Labor Summary %',
        component: () => import('./LaborSummary.vue'),
        permissions: ['thLaborSummary'],
      },
      {
        path: '/reports/timhortons/labor/laborSchedules',
        name: 'Labor Schedules',
        component: () => import('../../standard/labor/LaborSchedules.vue'),
        permissions: ['thLaborSchedules'],
      },
    ]
  };

  export default routes;